
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M72.17 69.19A87.61 87.61 0 0183.6 71.5M54.6 68.56c1.84-.12 3.69-.17 5.56-.17s4 .06 6 .19M36.4 71.58A89.26 89.26 0 0148 69.2M72.23 75.7A86.19 86.19 0 0183.5 78M54.7 75.07c1.85-.11 3.7-.17 5.57-.17s4 .07 5.95.2M36.28 78.1a93 93 0 0111.8-2.38M30 94.73h60V108H30zM90 54.25a89.79 89.79 0 00-60 0v-9.68a89.79 89.79 0 0160 0zM47.88 93.76V49.25M54.25 49.25v44.51M65.75 93.76V49.25M72.12 49.25v44.51M30 93.76V54.52M36.37 52.41v41.35M83.63 93.76V52.41M90 54.52v39.24M59.95 39.62V20","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M88.82 94.03l18.3 6.14V108M31.18 94.03l-18.3 6.14V108M90.19 44.79h26.87v9.28H90.19"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M117.06 54.07V108H87.74M29.81 44.79H2.94v9.28h26.87M2.94 54.07V108h29.32M59.95 20h10v6h-10z"}})])
          )
        }
      }
    